import { createContext } from "react";
import { useSound } from "../hooks/useSound";

export const SoundContext = createContext<ReturnType<typeof useSound>>(null);
